import { render, staticRenderFns } from "./PortalCard.vue?vue&type=template&id=40af53ca&scoped=true&"
import script from "./PortalCard.vue?vue&type=script&lang=ts&"
export * from "./PortalCard.vue?vue&type=script&lang=ts&"
import style0 from "./PortalCard.vue?vue&type=style&index=0&id=40af53ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40af53ca",
  null
  
)

export default component.exports